module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-detail-header"
  }, [_c('div', {
    staticClass: "course-detail-header--wrapper"
  }, [_c('cmp-entry-animation', {
    staticClass: "course-detail-header--entry-animation",
    attrs: {
      "variant": _vm.entryAnimationVariant,
      "is-triggered": _vm.isTriggered
    }
  }, [_c('transition', {
    attrs: {
      "slot": "presvg",
      "name": "trs-cdh-fade"
    },
    slot: "presvg"
  }, [(_vm.isTriggered) ? _c('div', {
    key: _vm.header.slug,
    staticClass: "course-detail-header--bg trs-cdh-fade"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "slot": "postsvg",
      "name": "trs-cdh-fade"
    },
    slot: "postsvg"
  }, [(_vm.isTriggered) ? _c('div', {
    key: _vm.header.slug,
    staticClass: "course-detail-header--content trs-cdh-fade"
  }, [_c('div', {
    staticClass: "grid--container"
  }, [_c('div', {
    staticClass: "grid--row"
  }, [_c('div', {
    staticClass: "grid--col course-detail-header--aside"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid--col course-detail-header--main"
  }, [_c('div', {
    staticClass: "course-detail-header--root"
  }, [_c('div', {
    staticClass: "course-detail-header--inner"
  }, [_c('h1', {
    staticClass: "course-detail-header--title trs-cdh-fade--title",
    domProps: {
      "innerHTML": _vm._s(_vm.header.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "course-detail-header--subtitle trs-cdh-fade--subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.header.subtitle)
    }
  })])])])])])]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-670033a3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-670033a3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-placeholders/course-detail-header/index.vue
// module id = 554
// module chunks = 7